import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { AuthProvider } from './context/AuthContext'
import { LanguageProvider } from './context/LanguageContext'
import { ProfileProvider } from './context/ProfileContext'
import { SidebarBadgeProvider } from './context/SidebarBadgeContext'
import { DialogProvider } from './context/DialogContext'
import { WebSocketProvider } from './context/WebSocketContext'
import { ImpersonationBanner } from './components/ImpersonationBanner'
import AppRoutes from './routes'

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <WebSocketProvider>
            <ProfileProvider>
              <SidebarBadgeProvider>
                <DialogProvider>
                  <ImpersonationBanner />
                  <AppRoutes />
                  <Toaster position="top-right" />
                </DialogProvider>
              </SidebarBadgeProvider>
            </ProfileProvider>
          </WebSocketProvider>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  )
}

export default App
